import axiosInstance from "./api-service";
import azureService from "./azure-service";
 
const setup = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
 
  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;
      if (originalConfig.url !== "/auth/login" && err.response) {
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            const msal = await azureService.getMsalInstance();
            const accounts = msal.getAllAccounts();
            if (!accounts.length) {
              store.dispatch("auth/logout");
              return Promise.reject(err);
            }
            const result = await msal.acquireTokenSilent({
              scopes: azureService.getB2cScopes(),
              account: accounts[0],
            });
            const newToken = result.accessToken;
            localStorage.setItem("access_token", newToken);
            store.commit("auth/LOGIN_SUCCESS", {
              token: newToken,
              user: store.state.auth?.user,
            });
            originalConfig.headers["Authorization"] = "Bearer " + newToken;
            return axiosInstance(originalConfig);
          } catch (_error) {
            store.dispatch("auth/logout");
            return Promise.reject(_error);
          }
        }
      }
      return Promise.reject(err);
    }
  );
};
 
export default setup;